export const ACTION_CODE = 'NOTIFICATION' + '_ACTION';
